import * as React from "react";
import {
  Box,
  Button,
  Breadcrumbs,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import style from "../../../assets/css/proposal.module.scss";

import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {selectUiState, setUiData} from "../../../store/uiSlice";

import {AGENT_CLAIM_LIST, CLAIM_LIST} from "../../../constants/apiConstant";
import {removeCookies} from "../../../constants/helper";

import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import NoDataComponent from "../../no-data";
import {CgCloseR} from "react-icons/cg";
import {BsCheckSquare} from "react-icons/bs";
import {useState} from "react";
import {useMemo} from "react";
import {useCallback} from "react";
import {useEffect} from "react";

const columns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "policy_number", label: "Policy Number", minWidth: 160},
  {id: "loss_date", label: "Date of Loss", minWidth: 110},
  {id: "date_reported", label: "Date Reported", minWidth: 110},
  {
    id: "formated_estimated_loss_amount",
    label: "Estimated Loss",
    minWidth: 160,
  },
  {id: "loss_type", label: "Type of Loss", minWidth: 100},
  {id: "status", label: "Claim Status", minWidth: 100},
  {id: "status", label: "Paid Out", minWidth: 70},
  {id: "formated_paid_amount", label: "Paid Amount", minWidth: 120},
];

const agentColumns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "company", label: "Company Name", minWidth: 45},
  // {id: "full_name", label: "Client Name", minWidth: 45},
  ...columns.slice(1),
];

const ClaimHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {user} = useSelector(selectAuthState);
  const {showLoader} = useSelector(selectUiState);
  const {claimListData, claimListCount, claimHistoryParentProposal} =
    useSelector(selectDataStoreState);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const claimList = useMemo(() => claimListData || [], [claimListData]);

  const fetchClaimsList = useCallback(async () => {
    if (page === null || rowsPerPage === null) {
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    };
    if (claimHistoryParentProposal) {
      data.proposal_id = claimHistoryParentProposal?.proposal_id;
    }
    let apiDetails = {
      method: CLAIM_LIST.method,
      headers: CLAIM_LIST.headers,
      url: CLAIM_LIST.url,
    };

    if (user?.user_type === "agent") {
      //data.agent_id = 56;
      data.agent_id = user?.id;

      apiDetails = {
        method: AGENT_CLAIM_LIST.method,
        headers: AGENT_CLAIM_LIST.headers,
        url: AGENT_CLAIM_LIST.url,
      };
    } else {
      data.user_id = user?.id;
    }
    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();
      if (res.status == 1) {
        dispatch(
          setDataStore({
            claimListData: res?.claim_list || [],
            claimListCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching Claims");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [page, rowsPerPage, claimHistoryParentProposal]);

  useEffect(() => {
    fetchClaimsList();
  }, [fetchClaimsList]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const paginationInputs = document.querySelectorAll(
      ".MuiSelect-nativeInput"
    );
    paginationInputs.forEach((input, index) => {
      // Add aria-label only if not already present
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", `Page number input ${index + 1}`);
      }
    });
  }, []);

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>

              <Typography sx={{color: "text.primary"}}>
                Claim History
              </Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.propUnderProgTitle}>
              <h3> Claim History </h3>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={claimListCount || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                disabled={claimListData?.length <= 0}
              />
            </div>

            <Paper className={style.propTableMain}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(user?.user_type === "agent"
                        ? agentColumns
                        : columns
                      ).map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {claimList.length > 0 && (
                    <TableBody>
                      {claimList.map((row, idx) => (
                        <TableRow key={row.id}>
                          <TableCell>{idx + 1}</TableCell>
                          {user?.user_type === "agent" && (
                            <TableCell>{row.company}</TableCell>
                            // <TableCell>{row.full_name}</TableCell>
                          )}
                          {/* <TableCell>{row.policy_number}</TableCell> */}
                          <TableCell>
                            <div>
                              <Link
                                to={"/details/policy/" + row.proposal_id}
                                style={{color: "#000"}}
                              >
                                {row.policy_number}
                              </Link>
                            </div>
                          </TableCell>

                          <TableCell>{row.loss_date}</TableCell>
                          <TableCell>{row.date_reported}</TableCell>
                          <TableCell>
                            {row.formated_estimated_loss_amount}
                          </TableCell>
                          <TableCell>{row.loss_type}</TableCell>
                          <TableCell>
                            {{
                              0: (
                                <Button
                                  disabled
                                  style={{color: "#ff8607"}}
                                  className={style.IssuedPolicyBtnDanger}
                                >
                                  Pending
                                </Button>
                              ),
                              1: (
                                <Button
                                  disabled
                                  style={{color: "#00ba34"}}
                                  className={style.IssuedPolicyBtnSucces}
                                >
                                  Approved
                                </Button>
                              ),
                              2: (
                                <Button
                                  disabled
                                  style={{color: "#ff3d32"}}
                                  className={style.IssuedPolicyBtnExpired}
                                >
                                  Rejected
                                </Button>
                              ),
                            }[row.status] || "-"}
                          </TableCell>
                          <TableCell>
                            {row.status == 1 ? (
                              <BsCheckSquare color="#00BA34" size={24} />
                            ) : (
                              <CgCloseR color="#FF2116" size={26} />
                            )}
                          </TableCell>
                          <TableCell>{row.formated_paid_amount}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
                {!claimList.length && !showLoader && <NoDataComponent />}
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default ClaimHistory;
